export const SPINNER_COLORS = {
    primary: 'primary',
    secondary: 'secondary',
    tertiary: 'tertiary',
    destructive: 'destructive',
    success: 'success',
    warning: 'warning',
    info: 'info',
} as const

export const SPINNER_COLORS_ARRAY = Object.values(SPINNER_COLORS)
